var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-container"},[_c('p',{staticClass:"step-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"step-sub-title"},[_vm._v(_vm._s(_vm.subTitle))]),_c('img',{staticClass:"step-img",attrs:{"src":_vm.img}})])
}
var staticRenderFns = []

export { render, staticRenderFns }